import abastecimento from './menu-routes-api/abastecimento'
import adminEscolar from './menu-routes-api/adminEscolar'
import adminGeral from './menu-routes-api/adminGeral'
import despacho from './menu-routes-api/despacho'
import diariosBordo from './menu-routes-api/diariosBordo'
import documentacao from './menu-routes-api/documentacao'
import estoque from './menu-routes-api/estoque'
import gestaoEscala from './menu-routes-api/gestaoEscala'
import gestaoContratos from './menu-routes-api/gestaoContratos'
import gestaoMalha from './menu-routes-api/gestaoMalha'
import hfdm from './menu-routes-api/hfdm'
import inicio from './menu-routes-api/inicio'
import leiAviador from './menu-routes-api/leiAviador'
import monitoramento from './menu-routes-api/monitoramento'
import ordemMissao from './menu-routes-api/ordemMissao'
import perfil from './menu-routes-api/perfil'
import prevencao from './menu-routes-api/prevencao'
import programacaoDeVoo from './menu-routes-api/programacaoDeVoo'
import quadroAtividades from './menu-routes-api/quadroAtividades'
import rastreamento from './menu-routes-api/rastreamento'
import relatorios from './menu-routes-api/relatorios'
import restritos from './menu-routes-api/restritos'
import segurancaOperacional from './menu-routes-api/segurancaOperacional'
import solicitacao from './menu-routes-api/solicitacao'
import suporte from './menu-routes-api/suporte'
import usuario from './menu-routes-api/usuario'
import manutencao from './menu-routes-api/manutencao'
import loadView from './helpers/loadView'
import createRoute from './helpers/createRoute'

const Menu = 'modules/layout/menu/main'
let children = []
const menuDadosComponentes = [
	abastecimento,
	adminEscolar,
	adminGeral,
	despacho,
	diariosBordo,
	documentacao,
	estoque,
	gestaoEscala,
	gestaoContratos,
	gestaoMalha,
	hfdm,
	inicio,
	leiAviador,
	monitoramento,
	ordemMissao,
	perfil,
	prevencao,
	programacaoDeVoo,
	quadroAtividades,
	rastreamento,
	relatorios,
	restritos,
	segurancaOperacional,
	solicitacao,
	suporte,
	usuario,
	manutencao
]

menuDadosComponentes.forEach((componente) => {
	children.push(
		...componente.map((rota) =>
			createRoute(
				rota.modulo,
				rota.privilegio,
				rota.routerPath,
				rota.componentPath,
				rota.routerName,
				rota.componentName,
				rota.clientsComponentPath || [],
				rota.props || false,
			)
		)
	)
})

export default {
	path: '/',
	component: loadView(Menu),
	name: 'menu',
	children
}
